'use client';

import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import type { ReactNode } from 'react';

export const ModalButtonsWrapper = ({
  children,
  hasBaseContent = true,
}: {
  children: ReactNode;
  hasBaseContent?: boolean;
}) => (
  <div
    className={twMerge(
      clsx(
        'flex w-full flex-col gap-b px-e py-d md:flex-row md:py-c lg:px-d lg:py-b',
        {
          'border-t border-t-gray-300': hasBaseContent,
        }
      )
    )}
  >
    {children}
  </div>
);
